var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({class:[
    'triangle-btn',
    {
      'triangle-btn-active': _vm.active,
    },
  ],attrs:{"loading":_vm.loading,"icon":""}},_vm.$listeners),[_c('vue-icon',{attrs:{"icon":"triangleIcon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }